import React from "react"
import Tooltip from "app/static/frontend/components/Tooltip"
import Icon from "app/static/frontend/components/Icon"
import PropTypes from "prop-types"

export const ClearFilterButton = ({ id, clearFilter, label, columnIndex, dataCy }) => (
    <Tooltip label={label}>
        <div>
            <Icon name="fa-times-circle-o" data-cy={dataCy} onClick={() => clearFilter(id, columnIndex)} />
        </div>
    </Tooltip>
)

ClearFilterButton.propTypes = {
    id: PropTypes.string.isRequired,
    clearFilter: PropTypes.func.isRequired,
    label: PropTypes.string,
}

ClearFilterButton.defaultProps = {
    label: "Click to Clear Filtering",
}

export default ClearFilterButton
